import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

const RedirectToSubmodule = React.lazy(
  () => import('modules/analytics/components/RedirectToSubmodule')
)

export const analyticsRoutes = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      path: navigation.analytics.path,
      element: <RedirectToSubmodule />,
      handle: {
        module: 'analytics',
        moduleName: () => i18n.t('sidebar.analytics'),
        meta: () => ({
          title: i18n.t('sidebar.analytics'),
        }),
      },
    }),
  ]
})
